import React from 'react';
import { Menu, Item, Separator } from 'react-contexify';
import { Icon } from '../_components';
import { useModal } from '../_contexts';

export function MapPinMenu() {
  const { openModal } = useModal();

  const handleEditMarker = (event) => {
    // console.log('Show the Modal!', event);
    openModal('mapMarker', { event });
  };

  const handleDeleteMarker = (event) => {
    // console.log('Delete Confirmation Modal', event);
    openModal('confirmDelete', { type: 'marker', item: event.props.marker });
  };

  return (
    <Menu
      id="chronos-map-pin-context-menu"
      className="chronos-context-menu chronos-context-map-menu"
    >
      <Item onClick={handleEditMarker}>
        <Icon icon="fas fa-edit fa-fw" />
        &nbsp; Edit Marker
      </Item>
      <Separator />
      <Item onClick={handleDeleteMarker}>
        <Icon icon="fas fa-trash fa-fw" />
        &nbsp; Delete Marker
      </Item>
    </Menu>
  );
}
